/**
 * 엑셀 압축 파일 비밀번호 — BE `PasswordValidator` 오프라인 미러: 8자 이상 + 대·소문자·숫자·특수문자 각 1개 이상 + 공백 불가.
 * 특수문자는 BE `!Character.isLetterOrDigit && !isWhitespace` 와 같게 유니코드 문자·숫자가 아닌 것으로 본다 —
 * ASCII 기준(`[^A-Za-z0-9]`)이면 한글을 특수문자로 세어 BE 가 400 을 내는 비밀번호를 통과시킨다.
 */
export const isValidDownloadPassword = (password: string): boolean =>
  password.length >= 8 &&
  /[A-Z]/.test(password) &&
  /[a-z]/.test(password) &&
  /\d/.test(password) &&
  /[^\p{L}\p{N}\s]/u.test(password) &&
  !/\s/.test(password)

export const DOWNLOAD_PASSWORD_INVALID_MESSAGE = '파일 비밀번호는 8자 이상, 대문자·소문자·숫자·특수문자를 모두 포함해야 합니다(공백 불가).'
